import { render, staticRenderFns } from "./NormativeList.vue?vue&type=template&id=7218dbae&"
import script from "./NormativeList.vue?vue&type=script&lang=js&"
export * from "./NormativeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NormativeList.vue"
export default component.exports